import {getInviteVisitorFormSetting, getVisitorConfigSetting} from "@/api/setting-api";

export const mixin_table = {
    data() {
        return {
            addDialogVisible: false,
            editDialogVisible: false,
            showDialogVisible: false,

            tableData: [],
            tableShowData: [],
            tableAllData: [],

            index: 0,
            pagiTotal: 0,
            pagiPageSize: 10
        }
    },

    methods: {
        initPaginationTable() {
            this.tableData = this.tableShowData.slice(0, this.pagiPageSize)
            this.pagiTotal = this.tableShowData.length
            this.index = 0
        },

        handlePagination(val) {
            if (val < 1) {
                this.initPaginationTable()
                return
            }

            let begin = (val - 1) * this.pagiPageSize

            let end = val * this.pagiPageSize
            end = end > this.pagiTotal ? this.pagiTotal : end

            this.tableData = this.tableShowData.slice(begin, end)
        },

        couldRequestNextPage() {
            return (this.index + 2) * this.pagiPageSize > this.tableAllData.length
        }
    }
}

export const mixin_page_table = {
    data() {
        return {
            tableData: [],

            pageSizes: [10, 20, 50, 100],
            pagerCount: 7,

            curPageIndex: 0,
            curPageSize: 10,
            totalCount: 0,
        }
    },

    methods: {
        handleSizeChange(val) {
            this.curPageSize = val
            this.refreshTableData()
        },
        handleCurrentChange(val) {
            this.curPageIndex = val
            this.refreshTableData()
        },
    }
}


export const mixin_clearPhoneNumShow = {
    data() {
        return {
            phoneNumShow: false,
            clearPhoneNumDialog: {
                isShow: false,
                pageName: "",
                typeForFixButton: false,
            }
        }
    },

    methods: {
        cleartextShow(pageName) {
            console.log("cleartextShow", pageName)
            if (this.phoneNumShow) {
                this.$message.success("已经验证通过")
                return
            }
            this.clearPhoneNumDialog.pageName = pageName
            this.clearPhoneNumDialog.typeForFixButton = false
            this.clearPhoneNumDialog.isShow = true
        },


        clearDialogClose(result, timeIndex) {
            console.log("clearDialogClose", result, timeIndex)
            if (result) {
                if (this.clearPhoneNumDialog.typeForFixButton) {
                    let targetTime = new Date().getTime() + timeIndex * 30 * 60 * 1000
                    this.$store.commit('setFixButtonCheckPassTime', targetTime);
                } else {
                    this.phoneNumShow = true
                }
            }
            this.clearPhoneNumDialog.isShow = false
        },

        toFixShowTel(telNo) {
            if (telNo == null || telNo.length < 11) {
                return telNo
            }
            return telNo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        },

        checkFixButtonPass(pageName) {
            let now = new Date().getTime()
            let fixButtonCheckPassTime = this.$store.state.fixButtonPassTime

            if (now < fixButtonCheckPassTime) {
                return true
            } else {
                this.clearPhoneNumDialog = {
                    isShow: true,
                    typeForFixButton: true,
                    pageName: pageName,
                }
            }
        }

    },

}


export const mixin_visitor_setting = {
    data() {
        return {
            // 访客记录中，详情页宽度根据表格宽度
            tableWidth: 550,// 表格宽度参考

            visitorSettingData: {
                idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
                nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
                passport: 1, // 护照设置  1不展示， 2选填， 3必填； 默认不展示
                value: "NONE", // NONE ID PASSPORT ALL: ALL定义为 ID PASSPORT都可以，二选一
                depends: [
                    {name: "ID", dependField: ""},
                    {name: "PASSPORT", dependField: ""},
                ]
            },
            visitorShowSetting: {
                showIC: true,
                showNationality: false,
                showPassport: false,
                showEmail: false,
            },

            rules: {
                name: [{required: true, message: '请输入名称', trigger: 'change'},],
                tel: [{required: true, message: '请输入手机号', trigger: 'change'},],
                company: [{required: true, message: '请输入公司', trigger: 'change'},],
            },
        }
    },

    methods: {

        // TODO： 员工助手需求来时修改，调用 mobile 接口
        async setupWithMobile() {

        },

        async setupVisitorSetting(type) {
            switch (type) {
                case "USUAL":
                case "VISITOR_BOOK":
                case "SCENE_APPLY":
                case "BOOK_APPLY":
                    await this.setupBookVisitorSetting()
                    break
                case "VISITOR_INVITE":
                case "INVITE_APPLY":
                    await this.setupInviteVisitorSetting()
                    break
                default:
                    throw new Error("setupVisitorSetting type error::" + type)
            }
        },

        async setupBookVisitorSetting() {
            let result = await getVisitorConfigSetting()
            console.log("getVisitorConfigSetting", result)
            if (result.status === 200 && result.data.code === 200 && result.data.data.length === 1) {
                let content = JSON.parse(result.data.data[0].content)
                this.parseVisitorContent(content)
            } else {
                console.log("getVisitorConfigSetting empty, use default", result.data)
            }
        },

        async setupInviteVisitorSetting() {
            try {
                const {data} = await getInviteVisitorFormSetting();
                console.log("getInviteVisitorFormSetting", data);

                if (data.code === 200 && data.data.length === 1) {
                    let content = JSON.parse(data.data[0].content);
                    this.parseVisitorContent(content);
                } else {
                    console.log("getInviteVisitorFormSetting empty, use default", data);
                }
            } catch (err) {
                console.log("getInviteVisitorFormSetting", err);
            }
        },

        computeTableWidth() {
            let baseWidth = 360
            if (this.visitorShowSetting.showIC) {
                baseWidth += 160
            }
            if (this.visitorShowSetting.showNationality) {
                baseWidth += 120
            }
            if (this.visitorShowSetting.showPassport) {
                baseWidth += 100
            }
            if (this.visitorShowSetting.showEmail) {
                baseWidth += 120
            }
            if (baseWidth > 550) {
                this.tableWidth = baseWidth
            }
        },

        validateIdCard(idCard) {
            if (!idCard || idCard.trim() === '') return true;
            const trimmed = idCard.trim();

            const isValidDate = (yearStr, monthStr, dayStr) => {
                const year = parseInt(yearStr, 10);
                const month = parseInt(monthStr, 10);
                const day = parseInt(dayStr, 10);
                const date = new Date(year, month - 1, day);
                return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
            };

            if (trimmed.length === 18) {
                const pattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
                if (!pattern.test(trimmed)) return false;

                const year = trimmed.substring(6, 10);
                const month = trimmed.substring(10, 12);
                const day = trimmed.substring(12, 14);
                if (!isValidDate(year, month, day)) return false;

                const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
                let sum = 0;
                for (let i = 0; i < 17; i++) {
                    sum += parseInt(trimmed[i]) * weights[i];
                }
                return trimmed[17].toUpperCase() === checkCodes[sum % 11];
            }

            if (trimmed.length === 15) {
                const pattern = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/;
                if (!pattern.test(trimmed)) return false;

                const year = '19' + trimmed.substring(6, 8);
                const month = trimmed.substring(8, 10);
                const day = trimmed.substring(10, 12);
                return isValidDate(year, month, day);
            }

            return false;
        },

        setupVisitorForms() {
            const icValidator = (rule, value, callback) => {
                if (!value || value.trim() === '') {
                    if (this.visitorSettingData.idCardNo === 3 || this.visitorSettingData.value === "ID") {
                        callback(new Error('请输入身份证号'))
                    } else {
                        callback()
                    }
                    return
                }
                if (!this.validateIdCard(value)) {
                    callback(new Error('身份证号格式错误'))
                } else {
                    callback()
                }
            }
            if (this.visitorSettingData.idCardNo === 3 || this.visitorSettingData.value === "ID") {
                this.rules.ic = [{validator: icValidator, trigger: 'change'},]
            } else if (this.visitorSettingData.idCardNo === 2) {
                this.rules.ic = [{validator: icValidator, trigger: 'change'}]
            }
            if (this.visitorSettingData.nationality === 3) {
                this.rules.nationality = [{required: true, message: '请输入国籍', trigger: 'change'},]
            }
            if (this.visitorSettingData.passport === 3 || this.visitorSettingData.value === "PASSPORT") {
                this.rules.tag = [{required: true, message: '请输入护照号', trigger: 'change'},]
            }
        },

        checkoutVisitorValidate(visitor) {
            console.log("checkoutVisitorValidate", visitor, this.visitorSettingData)
            // 姓名， 手机号， 公司 必填
            if (!visitor.name || !visitor.tel || !visitor.company) {
                this.$message.error("姓名，手机号，公司为必填项")
                return false
            }
            // 设置必填项
            if (this.visitorSettingData.idCardNo === 3 && !visitor.ic) {
                this.$message.error("身份证号为必填项")
                return false
            }
            if (this.visitorSettingData.nationality === 3 && !visitor.nationality) {
                this.$message.error("国籍为必填项")
                return false
            }
            if (this.visitorSettingData.passport === 3 && !visitor.tag) {
                this.$message.error("护照号为必填项")
                return false
            }
            // 设置依赖项
            switch (this.visitorSettingData.value) {
                case "ID":
                    if (!visitor.ic) {
                        this.$message.error("身份证号为必填项")
                        return false
                    } else {
                        let depend = this.visitorSettingData.depends.find(item => item.name === "ID")
                        if (depend && depend.dependField === "email" && !visitor.email) {
                            this.$message.error("身份证号依赖邮箱，身份证填写时邮箱为必填项")
                            return false
                        }
                    }
                    break
                case "PASSPORT":
                    if (!visitor.tag) {
                        this.$message.error("护照号为必填项")
                        return false
                    } else {
                        let depend = this.visitorSettingData.depends.find(item => item.name === "PASSPORT")
                        if (depend && depend.dependField === "email" && !visitor.email) {
                            this.$message.error("护照号依赖邮箱，护照号填写时邮箱为必填项")
                            return false
                        }
                    }
                    break
                case "ALL":
                    if (!visitor.ic && !visitor.tag) {
                        this.$message.error("身份证号或护照号至少填写一个")
                        return false
                    } else {
                        let icNeedEmail = false
                        let tagNeedEmail = false
                        this.visitorSettingData.depends.forEach(item => {
                            if (item.name === "ID" && item.dependField === "email") {
                                icNeedEmail = true
                            }
                            if (item.name === "PASSPORT" && item.dependField === "email") {
                                tagNeedEmail = true
                            }
                        })
                        if (visitor.ic && icNeedEmail && !visitor.email) {
                            this.$message.error("身份证号依赖邮箱，身份证填写时邮箱为必填项")
                            return false
                        }
                        if (visitor.tag && tagNeedEmail && !visitor.email) {
                            this.$message.error("护照号依赖邮箱，护照号填写时邮箱为必填项")
                            return false
                        }
                    }
                    break
                default:
                    break
            }
            // check pass
            return true
        },

        parseVisitorContent(content) {
            if (!content) {
                return
            }

            this.visitorSettingData = content

            if (content.idCardNo > 1) {
                this.visitorShowSetting.showIC = true
            } else {
                this.visitorShowSetting.showIC = false
            }
            if (content.nationality > 1) {
                this.visitorShowSetting.showNationality = true
            }
            if (content.passport > 1) {
                this.visitorShowSetting.showPassport = true
            }
            let depend;
            switch (content.value) {
                case "ID":
                    this.visitorShowSetting.showPassport = true
                    depend = content.depends.find(item => item.name === "ID")
                    if (depend && depend.dependField === "email") {
                        this.visitorShowSetting.showEmail = true
                    }
                    break
                case "PASSPORT":
                    this.visitorShowSetting.showIC = true
                    depend = content.depends.find(item => item.name === "PASSPORT")
                    if (depend && depend.dependField === "email") {
                        this.visitorShowSetting.showEmail = true
                    }
                    break
                case "ALL":
                    this.visitorShowSetting.showPassport = true
                    this.visitorShowSetting.showIC = true
                    content.depends.forEach(item => {
                        if (item.dependField === "email") {
                            this.visitorShowSetting.showEmail = true
                        }
                    })
                    break
                default:
                    break
            }

            this.computeTableWidth();
            this.setupVisitorForms();
        }
    }
}
